var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"visible":true,"size":"sm","centered":"","hide-header":"","hide-footer":"","no-close-on-backdrop":"","body-class":"sedna_loading_modal_body"}},[_c('div',{staticClass:"text-center"},[_c('loading-spinner'),_c('p',{staticClass:"sedna_loading_modal_title"},[_vm._v("Just a moment...")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }